import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, useSeo } from "@/lib/api";
import Breadcrumbs from "@/components/Breadcrumbs";
import { ArrowRight } from "lucide-react";

export default function Categories() {
  useSeo("Coupon Categories — SharePromos", "Browse verified deals by category: fashion, tech, food, travel, home, beauty and more.", {
    keywords: "coupon categories, deal categories, fashion coupons, tech coupons, food coupons, travel deals, home coupons, beauty promos",
  });
  const [cats, setCats] = useState([]);
  useEffect(() => { api.get("/categories").then((r) => setCats(r.data)); }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 md:py-20" data-testid="categories-page">
      <Breadcrumbs items={[{ label: "Categories" }]} />
      <p className="overline mb-4">Explore</p>
      <h1 className="font-display text-4xl md:text-6xl tracking-tighter uppercase mb-12">All Categories</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {cats.map((c, i) => (
          <Link key={c.slug} to={`/category/${c.slug}`}
                data-testid={`category-card-${c.slug}`}
                className="group border border-slate-200 bg-white hover-lift p-8 rounded-sm">
            <p className="overline text-slate-400 mb-4">0{i + 1}</p>
            <h2 className="font-display text-2xl tracking-tight mb-3 group-hover:text-emerald-600">{c.name}</h2>
            <p className="text-slate-600 leading-relaxed mb-6">{c.description}</p>
            <span className="inline-flex items-center gap-2 text-sm font-medium">
              Browse deals <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
